type ShinyTextProps = {
  text: string;
  className?: string;
};

export default function ShinyText({ text, className }: ShinyTextProps) {
  return (
    <span className={className ? `inbox-demo-shiny-text ${className}` : "inbox-demo-shiny-text"}>
      {text}
    </span>
  );
}
